"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastPortal = void 0;
var _lodestarCore = require("@smartsheet/lodestar-core");
var _react = _interopRequireDefault(require("react"));
const ToastPortal = _ref => {
  let {
    children,
    element
  } = _ref;
  if (!element) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement(_lodestarCore.Portal, {
      appendTo: element
    }, /*#__PURE__*/_react.default.createElement(_lodestarCore.LayerContextProvider, {
      defaultLayer: "toast"
    }, children));
  }
};
exports.ToastPortal = ToastPortal;
//# sourceMappingURL=ToastPortal.js.map